import { useContext } from "react";
import { Redirect, Route as RouterRoute } from "react-router-dom";

import BackdropLoading from "../components/BackdropLoading";
import { AuthContext } from "../context/Auth/AuthContext";

const Route = ({ 
  component: Component, 
  isPrivate = false, 
  isPublic = false, // Novo parâmetro para rotas acessíveis a todos
  ...rest 
}) => {

  const { isAuth, loading, user } = useContext(AuthContext);

  // Se a rota for pública, renderize o componente diretamente sem verificar autenticação
  if (isPublic) {
    return (
      <>
        {loading && <BackdropLoading />}
        <RouterRoute {...rest} component={Component} />
      </>
    );
  }

  // A partir daqui, sabemos que a rota não é pública
  
  if (loading || (isAuth && !user.id)) {
    return (<>
      <BackdropLoading />
    </>)
  }

  // Se o usuário não está autenticado e a rota é privada, redireciona para login
  if (!isAuth && isPrivate) {
    return (
      <>
        {loading && <BackdropLoading />}
        <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />
      </>
    );
  }

  // Se o usuário está autenticado e a rota não é privada, redireciona para a página inicial
  if (isAuth && !isPrivate) {
    return (
      <>
        {loading && <BackdropLoading />}
        <Redirect to={{ pathname: "/", state: { from: rest.location } }} />;
      </>
    );
  }

  // Outros casos, renderiza o componente normalmente
  return (
    <>
      {loading && <BackdropLoading />}
      <RouterRoute {...rest} component={Component} />
    </>
  );
};

export default Route;